import { CSOption } from "@components/Form/CSReactSelect"
import { CSTableServerPagination } from "@components/Table/CSTable"
import {EntityListResponseWarehouse, EntityListResponseWarehouseMovement, EntityListResponseWarehouseMovementViewSummary, EntitySingleResponseWarehouseMovement, Warehouse as ApiWharehouses, WarehouseMovementRequest } from "cs.node.utils/csapi/provisioning"
import { CurrentFilters } from "@utils/AdvancedFiltersUtils"
import { parseSort } from "@utils/ApiUtils"
import axios, { AxiosResponse } from "axios"
import { checkResponseStatus } from "./Utils"
import { endOfDay, startOfDay } from "date-fns"


const getWarehouses = async ():Promise<EntityListResponseWarehouse> =>{
    try {
        const response = await axios.get('api/warehouses')
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

const createWarehouse = async(warehouse: ApiWharehouses) =>{
    try {
        const params = { warehouse }
        const response = await axios.put(`api/warehouses/create/`,{params})
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}


const updateWarehouse = async(warehouse: ApiWharehouses) =>{
    try {
        const params = { warehouse }
        const response = await axios.put(`api/warehouses/update/`,{params})
        return response.data
    } catch(error:any) {
        throw error
    }
}

const getWarehousesMovementsByOrderId = async (orderId: string):Promise<EntityListResponseWarehouseMovement> =>{
    try {
        const response = await axios.get('api/warehouses/movements/listByOrderId', {
            params: { orderId }
        })
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

const getWarehouseMovement = async (movementId: string):Promise<EntitySingleResponseWarehouseMovement> =>{
    try {
        const response = await axios.get(`api/warehouses/movements/${movementId}`)
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

const getWarehousesMovementsByOrderIdSummary = async (orderId: string, pagination: CSTableServerPagination):Promise<EntityListResponseWarehouseMovementViewSummary> =>{
    try {
        const { _pageIndex, _pageSize, _sort } = pagination
        const sortParsed = parseSort(_sort, ["date","item.sku","item.title","item.brand","qty","absolute","warehouse.name","tags"])
        const params = {
            _pageIndex, 
            _pageSize,
            _sort: sortParsed,
            orderId
        }
        const response = await axios.get('api/warehouses/movements/listByOrderIdSummary', {
            params
        })
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

const getWarehousesMovementsByFilters = async (filters:CurrentFilters, pageIndex?: number, pageSize?: number | "ALL", sortObject?: [number | undefined, "ASC" | "DESC"], controller?: AbortController):Promise<EntityListResponseWarehouseMovementViewSummary> =>{
    try {
        const date = filters.find(filter=>filter.id==="date")
        const sku= filters.find(filter=>filter.id==="sku")?.value  as CSOption
        const itemId = sku?.value
        const filterDate = (date?.value?? [null, null]) as [Date|null, Date|null] 
        const dateFrom = filterDate[0]?startOfDay(filterDate[0]):null
        const dateTo = filterDate[1]?endOfDay(filterDate[1]):null
        const whs: CSOption[] | undefined = (filters.find(filter => filter.id === "warehouses")?.value as CSOption[]) ?? [];
        const provisioningWhsIds: string[] = whs.map(option =>option.value )

        let sort: string | undefined
        if(sortObject && sortObject[0] === 0 && !!sortObject[1]) {
            sort = `date[${sortObject[1]}]`
        }

        const params = {
            pageIndex, 
            pageSize,
            sort,
            itemId,
            dateFrom: dateFrom?.toISOString(),
            dateTo: dateTo?.toISOString(),
            whsIds : provisioningWhsIds
        }
        
        const response:AxiosResponse<EntityListResponseWarehouseMovementViewSummary> = await axios.get('api/warehouses/movements/listByFilter', {
            params,
            signal: controller?.signal
        })
        return response.data

    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

const addMovement = async (whId: string, body: WarehouseMovementRequest) => {
    try{
        const response = await axios.post(`api/warehouses/${whId}/movements`, body)
        return response.data

    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export {getWarehouses, getWarehousesMovementsByOrderId, getWarehousesMovementsByOrderIdSummary, getWarehousesMovementsByFilters, addMovement, createWarehouse,updateWarehouse, getWarehouseMovement }